module.exports = __webpack_public_path__ + "static/media/resultsCanTrust.5ad5c76d.png";